export const tasksTableHeadingsData = [
  "Task Date",
  "Task",
  "Customer name",
  "Policy",
  "Description",
  "Priority",
  "Status",
];
